/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import {
  ILoadingMethods,
  LoadingService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IUtiltiyCenterDetailsMethods,
  UtilityCenterDetailsService,
  IUpdateUtilityCenterMethods,
  UpdateUtilityCenterService,
} from "./components";

export type UtiltiyCenterDetailPageAgent = IStaticPageContentMethods &
  ILoadingMethods &
  IUtiltiyCenterDetailsMethods &
  IUpdateUtilityCenterMethods;

const getPlugins = () => {
  return [
    new LoadingService(),
    new StaticPageContentService(),
    new UtilityCenterDetailsService(),
    new UpdateUtilityCenterService(),
  ];
};

export const getAgent = () => {
  return createAgent<UtiltiyCenterDetailPageAgent>({
    plugins: getPlugins(),
  });
};
